import { Link } from 'expo-router';
import { StyleSheet } from 'react-native';

import { ActionSheet, Button, Text, YStack, tokens } from '@fhs/ui';
import { centsToDollarString } from '@fhs-legacy/frontend/src/utils';
import {
  CHECKOUT_DELIVERY_FEES_MODAL,
  CLOSE_DELIVERY_FEE_MODAL,
} from '@fhs-legacy/frontend/src/utils/test-ids';

type DeliveryFeesInfoModalProps = {
  baseFeeCents: number;
  geographicalFeeCents: number;
  onClose: () => void;
};

function DeliveryFeesInfoModal({
  baseFeeCents,
  geographicalFeeCents,
  onClose,
}: DeliveryFeesInfoModalProps) {
  const formattedBaseFee = centsToDollarString(baseFeeCents);
  const formattedGeographicalFee = centsToDollarString(geographicalFeeCents);

  return (
    <ActionSheet isVisible onClose={onClose} headerTitle="Delivery Fee">
      <YStack testID={CHECKOUT_DELIVERY_FEES_MODAL} style={modalStyles.container}>
        <YStack style={modalStyles.section}>
          <Text.Heading type="four">{`Base Fee: ${formattedBaseFee}`}</Text.Heading>
          <Text.Paragraph size="md">Fixed fee applied to each delivery order.</Text.Paragraph>
        </YStack>

        {geographicalFeeCents > 0 && (
          <YStack style={modalStyles.section}>
            <Text.Heading type="four">{`Geographical Fee: ${formattedGeographicalFee}`}</Text.Heading>
          </YStack>
        )}

        <Link href="/delivery-terms" asChild>
          <Text.Paragraph size="md" style={modalStyles.linkText}>
            Click here for full delivery terms.
          </Text.Paragraph>
        </Link>

        <Button type="solid" size="lg" onPress={onClose} testID={CLOSE_DELIVERY_FEE_MODAL}>
          <Button.Text>Okay</Button.Text>
        </Button>
      </YStack>
    </ActionSheet>
  );
}

export default DeliveryFeesInfoModal;

const modalStyles = StyleSheet.create({
  container: {
    gap: 24,
    padding: 24,
    paddingTop: 32,
  },
  section: {
    gap: 8,
  },
  linkText: {
    color: tokens.colors.$houseDark,
    textDecorationLine: 'underline',
  },
});
